import { GameSpinsRemainingProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameSpinsRemainingProperties";
/**
 * SpinsRemainingLandscapeProperties.ts
 */
export class SpinsRemainingLandscapeProperties extends GameSpinsRemainingProperties {
    constructor() {
        super();
        this.position.set(1667, 682);
    }
}
